import { __assign } from "tslib";
import * as React from 'react';
import { Box } from '../../Box';
import { Markdown } from '../../../extra/Markdown';
import Theme from '../../../theme';
import { LabelElement } from '../LabelElement';
import { WarningField } from '../WarningField';
import { Txt } from '../../Txt';
var REQUIRED_FIELD_SYMBOL = '*';
var Label = function (props) {
    var label = props.label, required = props.required, id = props.id;
    if (!label) {
        return null;
    }
    return (React.createElement(LabelElement, { className: "control-label", htmlFor: id },
        label,
        required && React.createElement("span", { className: "required" }, REQUIRED_FIELD_SYMBOL)));
};
var FieldTemplate = function (props) {
    var id = props.id, classNames = props.classNames, label = props.label, children = props.children, errors = props.errors, rawHelp = props.rawHelp, description = props.description, _a = props.hidden, hidden = _a === void 0 ? false : _a, _b = props.required, required = _b === void 0 ? false : _b, _c = props.displayLabel, displayLabel = _c === void 0 ? true : _c, uiSchema = props.uiSchema;
    if (hidden) {
        return children;
    }
    var warning = uiSchema['ui:warning'];
    return (React.createElement(Box, { mb: 2, className: (classNames || '') + " rendition-form__field--" + id },
        displayLabel && React.createElement(Label, { label: label, required: required, id: id }),
        displayLabel && !!warning && React.createElement(WarningField, { warning: warning }),
        displayLabel && description ? description : null,
        children,
        errors,
        rawHelp && (React.createElement(Markdown, { mt: 1, className: "rendition-form-help", color: Theme.colors.text.light, componentOverrides: {
                p: function (props) { return React.createElement(Txt.p, __assign({}, props, { margin: 0 })); },
            } }, rawHelp))));
};
export default FieldTemplate;
